module.exports = __webpack_public_path__ + "media/images/youtube-b5f21a65f9bab9c514864d26543a30d0.png";